import React from 'react';
import { FcGoogle } from "react-icons/fc";
import { useAccessCard } from '../../ContextProvider/Accesscardprovider';

const GoogleLoginCard = () => {
    const {google, setGoogle} = useAccessCard();
    const handleLogin = () => {
        console.log('Google login clicked');
        // Place Firebase / OAuth logic here
    };
    
    const closeGoogleCard = () => {
        setGoogle(!google)
    }

    return (
        <div className="google-login-card" onClick={(e) => e.stopPropagation()}>
            <span className='close-card' onClick={ closeGoogleCard }>X</span>
            <h2 className="login-title">Login</h2>
            <p className="login-subtitle">Login with your Google account</p>
            <button className="google-login-button" onClick={handleLogin}>
                <FcGoogle size={22} />
                <span>Continue with Google</span>
            </button>
        </div>

    );
};

export default GoogleLoginCard;